export default Object.freeze({
  Email: 'email',
});
